import { useFlags } from 'config/useFlagsContext'
import { isProd } from 'config/util'

import { ConfiguracaoAgendaOnline } from './ConfiguracaoAgendaOnlineBox'
import { ConfiguracaoAgendaOnlineDesabilitadoContent } from './ConfiguracaoAgendaOnlineDesabilitadoContent'
import { ConfiguracaoAgendaOnlineHabilitadoContent } from './ConfiguracaoAgendaOnlineHabilitadoContent'

interface InternetHabilitadaAgendaOnlineContentProps {
  agendaOnline: ConfiguracaoAgendaOnline
  isUnificandoBases: boolean
  refetch(): void
}

export function InternetHabilitadaAgendaOnlineContent(props: Readonly<InternetHabilitadaAgendaOnlineContentProps>) {
  const { agendaOnline, isUnificandoBases, refetch } = props

  const { HORARIO_FINAL_AGENDAMENTO_ENABLED } = useFlags()

  const isProdAndFlagEnabled = isProd() && HORARIO_FINAL_AGENDAMENTO_ENABLED
  const disabled = isUnificandoBases || isProdAndFlagEnabled

  return (
    <>
      {agendaOnline?.ativa ? (
        <ConfiguracaoAgendaOnlineHabilitadoContent agendaOnline={agendaOnline} refetch={refetch} />
      ) : (
        <ConfiguracaoAgendaOnlineDesabilitadoContent
          agendaOnline={agendaOnline}
          refetch={refetch}
          disabled={disabled}
          disabledTooltip={getDisabledTooltip(isProdAndFlagEnabled, isUnificandoBases)}
        />
      )}
    </>
  )
}

function getDisabledTooltip(isProdAndFlagEnabled: boolean, isUnificandoBases: boolean): string | undefined {
  if (isUnificandoBases) {
    return 'A Agenda Online não pode ser habilitada quando há uma Unificação de Bases em andamento.'
  } else if (isProdAndFlagEnabled) {
    return 'Não é possível gerar a chave da agenda online pois a funcionalidade de horário final na agenda está ativada.'
  }
  return undefined
}
